import { createFeatureSelector } from '@ngrx/store';
import * as fromNavigation from '../reducers';

export const selectNavigationState = createFeatureSelector<fromNavigation.NavigationState>(
  fromNavigation.navigationFeatureKey
);
